import React, { Component } from "react";
import { Button, SelectBox } from "devextreme-react";
import { SelectBoxOnValueChangedEvent } from "../../types/DevExtremeTypes";

const workerTimeRecordTypeList: Array<{ id: string; value: string }> = [
    { id: "", value: "All" },
    { id: "10", value: "Tap In" },
    { id: "20", value: "Tap Out" }
];

const workerTimeRecordStatusList: Array<{ id: string; value: string }> = [
    { id: "", value: "All" },
    { id: "10", value: "Pending" },
    { id: "20", value: "Completed" },
    { id: "30", value: "Exception" }
];

interface WorkerTimeRecordSidePanelProps {
    onApplyButtonClick: (workerTimeRecordTypeId: string, workerTimeRecordStatusId: string) => void;
}

interface WorkerTimeRecordSidePanelState {
    disableApplyButton: boolean;
    workerTimeRecordTypeId: string;
    workerTimeRecordStatusId: string;
}

class WorkerTimeRecordSidePanel extends Component<WorkerTimeRecordSidePanelProps> {
    state: WorkerTimeRecordSidePanelState;

    constructor(props: WorkerTimeRecordSidePanelProps) {
        super(props);
        this.state = {
            disableApplyButton: false,
            workerTimeRecordTypeId: "",
            workerTimeRecordStatusId: ""
        };
    }

    /**
     * Updates selected worker time record type filter.
     */
    handleChangeType = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        this.setState({
            workerTimeRecordTypeId: String(dxValueChange.value ?? "")
        });
    };

    /**
     * Updates selected worker time record status filter.
     */
    handleChangeStatus = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        this.setState({
            workerTimeRecordStatusId: String(dxValueChange.value ?? "")
        });
    };

    /**
     * Pushes selected filters to the parent page.
     */
    onApplyButtonClicked = () => {
        this.props.onApplyButtonClick(this.state.workerTimeRecordTypeId, this.state.workerTimeRecordStatusId);
    };

    render() {
        return (
            <div>
                <div className="row mt-4">
                    <div className="col-10">
                        <h4 className="sidebar__heading font-weight-bold">Filter</h4>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col sidebar__heading">Worker Time Record Type</div>
                </div>
                <div className="row mt-2">
                    <div className="col">
                        <SelectBox
                            dataSource={workerTimeRecordTypeList}
                            displayExpr="value"
                            valueExpr="id"
                            onValueChanged={this.handleChangeType}
                            value={this.state.workerTimeRecordTypeId}
                        />
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col sidebar__heading">Worker Time Record Status</div>
                </div>
                <div className="row mt-2">
                    <div className="col">
                        <SelectBox
                            dataSource={workerTimeRecordStatusList}
                            displayExpr="value"
                            valueExpr="id"
                            onValueChanged={this.handleChangeStatus}
                            value={this.state.workerTimeRecordStatusId}
                        />
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-6 mx-auto">
                        <Button
                            className="btn btn-primary btn--large"
                            disabled={this.state.disableApplyButton}
                            onClick={this.onApplyButtonClicked}
                        >
                            Apply
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default WorkerTimeRecordSidePanel;
